/**
 * Utility functions for number formatting and rounding to avoid floating point precision issues
 */

/**
 * Round a number to a specified number of decimal places
 * @param value - The number to round
 * @param decimalPlaces - Number of decimal places (default: 0)
 * @returns Rounded number
 */
export function roundNumber(value: number, decimalPlaces: number = 0): number {
  const multiplier = Math.pow(10, decimalPlaces);
  return Math.round(value * multiplier) / multiplier;
}

/**
 * Round numeric values for database storage
 * Maintains sufficient precision while preventing long floating point numbers
 * Examples: 0.123456789 → 0.1235, 25.00000001 → 25
 * @param value - The number to round
 * @returns Rounded number with 4 decimal places max
 */
export function roundForDatabase(value: number): number {
  return roundNumber(value, 4);
}

/**
 * Round numeric values for style calculations
 * Used for internal state management and calculations
 * @param value - The number to round
 * @returns Rounded number with 2 decimal places
 */
export function roundForStyle(value: number): number {
  return roundNumber(value, 2);
}
